import {  Link } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import styled from "styled-components";
import Container from "../presentation/Container";

const PaymentCanceled = () => (
  <Wrapper>
    <Container>
      
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Steps>
            <Typography variant="h3">Your payment is cancelled. please go to <Link href="/payment">Pay Now</Link> page again.. thanks</Typography>
          </Steps>
        </Grid>
      </Grid>
    </Container>
  </Wrapper>
);

export default PaymentCanceled;

const Wrapper = styled.div`
  padding: 70px 0;
  position: relative;
  background: #f7f9fb;

  @media (max-width: 992px) {
    padding: 40px 0;
  }

  .MuiButton-root {
    margin-top: 30px;
  }
`;

const Steps = styled.div`
  padding: 40px 20px;
  box-shadow: 0px 5px 18px rgb(0 0 0 / 10%);
  border-radius: 10px;
  background: #fff;
  text-align: center;
  position: relative;
  transition: 0.3s ease-in-out all;
  height: 100%;

  h3 {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 15px;

    @media (max-width: 992px) {
      font-size: 18px;
    }
  }
`;

